export const home = {
  hero: {
    title: "Listes de Leads de Qualité",
    subtitle: "Pour Équipes de Vente",
    description: "Arrêtez de perdre du temps avec de mauvais leads. Obtenez des numéros qui répondent, des entreprises qui existent, des données qui fonctionnent.",
    freeOffer: "100 Premiers Numéros GRATUITS",
    contactButton: "Contactez-Nous",
    callButton: "Appelez-Nous",
    pricing: "Ensuite €3 par numéro • Pas d&apos;abonnement • Pas de frais cachés"
  },
  whatWeDo: {
    title: "Pourquoi NovaVenture Est Meilleur",
    description: "D'autres listes sont pleines de numéros de fax, d'entreprises obsolètes et de numéros qui ne répondent jamais. Nous ne livrons que des données qui fonctionnent.",
    realPhone: {
      title: "Vrais Numéros de Téléphone",
      description: "Pas de numéros de fax. Pas de contacts obsolètes. Seulement des numéros répondus par de vraies entreprises."
    },
    activeCompanies: {
      title: "Entreprises Actives",
      description: "Toutes les entreprises filtrées par numéro de TVA. Plus d'entreprises en faillite ou inexistantes dans votre liste."
    },
    readyToUse: {
      title: "Prêt à l'Emploi",
      description: "Livré en Excel. Prêt à importer dans votre CRM. Commencez à appeler aujourd'hui."
    }
  },
  whatYouGet: {
    title: "Ce Que Vous Obtenez Par Lead",
    description: "Pas de données vagues. Pas d'arnaque de 'taille d'entreprise'. Seulement des informations concrètes dont votre équipe de vente a besoin.",
    fields: {
      companyName: {
        title: "Nom de l'Entreprise",
        description: "Nom officiel de l'entreprise"
      },
      vatNumber: {
        title: "Numéro de TVA",
        description: "Vérification que l'entreprise existe"
      },
      phoneNumber: {
        title: "Numéro de Téléphone",
        description: "Numéro de qualité qui répond"
      },
      fullAddress: {
        title: "Adresse Complète",
        description: "Rue, numéro, ville"
      },
      postalCode: {
        title: "Code Postal",
        description: "Pour le ciblage géographique"
      },
      website: {
        title: "Site Web",
        description: "Pour rechercher avant d'appeler"
      },
      reviews: {
        title: "Avis",
        description: "Si disponible"
      },
      openingHours: {
        title: "Heures d'Ouverture",
        description: "Savoir quand appeler"
      }
    },
    stats: {
      allBelgium: "Toute la Belgique",
      coverage: "Couverture complète",
      allSectors: "Tous les Secteurs",
      filterTarget: "Filtrer par votre cible",
      languages: "NL + FR",
      bothLanguages: "Les deux langues"
    }
  },
  pricing: {
    title: "Prix Transparents",
    description: "Pas d'abonnements. Pas de frais cachés. Payez uniquement ce que vous utilisez.",
    oneTimeOffer: "Offre Unique",
    freeNumbers: "100 Numéros",
    completelyFree: "Complètement GRATUIT",
    thenOnly: "Ensuite seulement",
    perNumber: "par numéro de téléphone",
    features: {
      noSubscription: "Aucun abonnement requis",
      noHiddenCosts: "Pas de frais cachés",
      payAsYouGo: "Payez uniquement ce que vous utilisez",
      excelDelivery: "Livré directement en Excel"
    },
    ctaButton: "Contactez-Nous Pour Vos Numéros Gratuits"
  },
  finalCta: {
    title: "Prêt à Commencer?",
    description: "Contactez-nous pour réclamer vos 100 numéros gratuits. Aucune carte de crédit requise.",
    emailButton: "Envoyer un Email",
    callButton: "Appelez-Nous Directement",
    email: "Email:",
    availability: "Disponible du lundi au vendredi • Réponse sous 24 heures"
  },
  dataPrivacy: {
    title: "Transparence Sur Le Traitement Des Données",
    description: "NovaVenture Group BV traite uniquement des données d'entreprises accessibles au public. Les entreprises peuvent s'opposer à l'inclusion dans notre base de données via",
    email: "David@novaventure.be",
    learnMore: "En savoir plus"
  }
};